import styled from "styled-components";
import { Button } from "../../styles/button";

const boxWidth = "300px";
const boxHeight = "320px";

export const CompanyBox = styled.div`
  box-shadow: 0px 0px 2px 2px rgba(0, 0, 0, 0.15);
  width: ${boxWidth};
  height: ${boxHeight};
  max-width: ${boxWidth};
  min-width: ${boxWidth};
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;

  flex: 1;
  text-align: center;
  border-radius: 4px;
  margin-right: 16px;

  transition: 0.075s;
  &:hover {
    transition: transform 0.075s;
    transform: scale(1.05);
  }
  @media (max-width: 400px) {
    display: block;
    width: 250px;
    height: 250px;
    max-width: 250px;
    margin: 16px auto;
  }
`;

export const BoxHeader = styled.div``;

export const CompanyName = styled.h2`
  color: #666;
  margin: 0;
  padding: 0;
  font-size: 1.25rem;
  letter-spacing: 2px;
  margin-bottom: 16px;
`;

export const PositionName = styled.h3`
  color: #666;
  margin: 0;
  padding: 0;
  font-size: 1rem;
  letter-spacing: 1.6px;
  margin-bottom: 16px;
`;

export const ViewButton = styled(Button)`
  background-color: #283678;
  color: white;
  border-color: #283678;
  margin: 0 auto;
  margin-top: 10px;
  border-radius: 5px;
  height: 40px;
  width: 200px;
`;

export const BaseBadge = styled.span`
  display: inline-block;
  background: transparent;
  border-radius: 4px;
  border: 2px solid blue;
  color: blue;
  font-size: 12px;
  padding: 4px 6px;
  text-align: center;
  margin: 10px 0px;
`;

const newBadgeColor = "#00BDCE";
export const NewBadge = styled(BaseBadge)`
  border: 2px solid ${newBadgeColor};
  color: ${newBadgeColor};
`;

const acceptBadgeColor = "#19A800";
export const AcceptBadge = styled(BaseBadge)`
  border: 2px solid ${acceptBadgeColor};
  color: ${acceptBadgeColor};
`;
const introdBadgeColor = "#045428";
export const IntrodBadge = styled(BaseBadge)`
  border: 2px solid ${introdBadgeColor};
  color: ${introdBadgeColor};
`;

const passBadgeColor = "#D13429";
export const PassBadge = styled(BaseBadge)`
  border: 2px solid ${passBadgeColor};
  color: ${passBadgeColor};
`;

export const Space = styled.div`
  width: 125px;
  height: 125px;
`;



// WEBPACK FOOTER //
// ./src/components/Grid/GridItem.styles.js